// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9rxfM","content":"styles_content__KzMmv","tableWrap":"styles_tableWrap__2u07y"};